import React, { useState } from 'react';
import './MobileAppSection.css';

const MobileAppSection = () => {
  const [activeApp, setActiveApp] = useState(0);

  const apps = [
    { name: 'Booking App', color: '#667eea' },
    { name: 'Food Delivery', color: '#f093fb' },
    { name: 'Fitness Tracker', color: '#4facfe' },
    { name: 'E-Commerce', color: '#43e97b' },
    { name: 'Social Media', color: '#fa709a' },
    { name: 'Banking', color: '#30cfd0' },
    { name: 'Travel', color: '#a8edea' },
    { name: 'Music Player', color: '#ffd89b' },
    { name: 'Messaging', color: '#19d1c8' },
    { name: 'Productivity', color: '#f5576c' }
  ];

  return (
    <section className="mobile-app-section section">
      <div className="section-content">
        <h2 className="section-title">Mobile App Showcase</h2>
        
        <div className="app-selectors">
          {apps.map((app, index) => (
            <div
              key={index}
              className={`app-selector ${activeApp === index ? 'active' : ''}`}
              onClick={() => setActiveApp(index)}
              style={{ '--selector-color': apps[activeApp].color }}
              title={app.name}
            />
          ))}
        </div>

        <div className="phones-container">
          {/* Android Phone */}
          <div className="phone android">
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="phone-screen">
                <div className="status-bar">
                  <span>9:41</span>
                  <div className="status-icons">
                    <span>📶</span>
                    <span>🔋</span>
                  </div>
                </div>
                <div className="app-content" style={{ background: `linear-gradient(180deg, ${apps[activeApp].color}, ${apps[activeApp].color}dd)` }}>
                  <div className="app-header">
                    <div className="app-icon" style={{ background: apps[activeApp].color }}>
                      📱
                    </div>
                    <h3>{apps[activeApp].name}</h3>
                  </div>
                  <div className="app-features">
                    <div className="feature-card">Feature 1</div>
                    <div className="feature-card">Feature 2</div>
                    <div className="feature-card">Feature 3</div>
                    <div className="feature-card">Feature 4</div>
                  </div>
                  <div className="app-button" style={{ background: apps[activeApp].color }}>
                    Get Started
                  </div>
                </div>
              </div>
              <div className="phone-buttons right"></div>
            </div>
            <div className="phone-label">Android</div>
          </div>

          {/* iPhone */}
          <div className="phone iphone">
            <div className="phone-frame">
              <div className="phone-notch-ios"></div>
              <div className="phone-screen">
                <div className="status-bar">
                  <span>9:41</span>
                  <div className="status-icons">
                    <span>📶</span>
                    <span>🔋</span>
                  </div>
                </div>
                <div className="app-content" style={{ background: `linear-gradient(180deg, ${apps[activeApp].color}, ${apps[activeApp].color}dd)` }}>
                  <div className="app-header">
                    <div className="app-icon" style={{ background: apps[activeApp].color }}>
                      📱
                    </div>
                    <h3>{apps[activeApp].name}</h3>
                  </div>
                  <div className="app-features">
                    <div className="feature-card">Feature 1</div>
                    <div className="feature-card">Feature 2</div>
                    <div className="feature-card">Feature 3</div>
                    <div className="feature-card">Feature 4</div>
                  </div>
                  <div className="app-button" style={{ background: apps[activeApp].color }}>
                    Get Started
                  </div>
                </div>
              </div>
              <div className="phone-buttons left"></div>
            </div>
            <div className="phone-label">iPhone</div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;
